import {cloneDeep, merge} from 'lodash';
import {DeepPartial} from 'utility-types';

import {PaletteColorsEnum} from '../../../../../core/src/models/api/paletteModel';
import {colorPrimitive} from '../../../styles/primitives/colorPrimitive';
import {redesignedDarkAccentSemanticStyles} from '../../semantic/accentSemanticStyles';
import {redesignedDarkAppFrameSemanticStyles} from '../../semantic/appFrameSemanticStyles';
import {redesignedDarkBackgroundSemanticStyles} from '../../semantic/backgroundSemanticStyles';
import {redesignedDarkBorderSemanticStyles} from '../../semantic/borderSemanticStyles';
import {redesignedDarkConversationCellSemanticStyles} from '../../semantic/cellSemanticStyles';
import {redesignedDarkCommentComposerSemanticStyles} from '../../semantic/commentComposerSemanticStyles';
import {redesignedDarkInlineBannerSemanticStyles} from '../../semantic/inlineBannerSemanticStyles';
import {redesignedDarkInputSemanticStyles} from '../../semantic/inputSemanticStyles';
import {redesignedDarkLeftBarSemanticStyles} from '../../semantic/leftBarSemanticStyles';
import {redesignedDarkMessageSemanticStyles} from '../../semantic/messageSemanticStyles';
import {redesignedDarkMetricsSemanticStyles} from '../../semantic/metricsSemanticStyles';
import {redesignedDarkSearchBarSemanticStyles} from '../../semantic/searchBarSemanticStyles';
import {redesignedDarkSidePanelSemanticStyles} from '../../semantic/sidePanelSemanticStyles';
import {redesignedDarkToggleSemanticStyles} from '../../semantic/toggleSemanticStyles';
import {redesignedDarkTopBarSemanticStyles} from '../../semantic/topBarSemanticStyles';
import {redesignedDarkVerticalSwitcherSemanticStyles} from '../../semantic/verticalSwitcherSemanticStyles';
import {UserTheme} from '../../themeTypes';
import {darkColors} from '../darkColors';
import {darkSidebarTheme, darkTheme, expandedDarkTheme} from '../darkTheme';

const overrides = {
  hasInboxRedesign: true,
  rounded: false,

  cell: redesignedDarkConversationCellSemanticStyles,

  leftBar: redesignedDarkLeftBarSemanticStyles,
  verticalSwitcher: redesignedDarkVerticalSwitcherSemanticStyles,

  background: redesignedDarkBackgroundSemanticStyles,
  accent: redesignedDarkAccentSemanticStyles,
  foreground: redesignedDarkBackgroundSemanticStyles.surface.highlight,

  appFrame: redesignedDarkAppFrameSemanticStyles,
  commentComposer: redesignedDarkCommentComposerSemanticStyles,
  message: redesignedDarkMessageSemanticStyles,
  topBar: redesignedDarkTopBarSemanticStyles,
  searchBar: redesignedDarkSearchBarSemanticStyles,
  sidePanel: redesignedDarkSidePanelSemanticStyles,

  typography: {
    shades: {
      interactive: colorPrimitive.blurple[500],
      'interactive-hover': colorPrimitive.blurple[600],

      link: colorPrimitive.blurple[500],
      'link-hover': colorPrimitive.blurple[600],
    },
  },
  input: redesignedDarkInputSemanticStyles,
  toggle: redesignedDarkToggleSemanticStyles,
  metrics: redesignedDarkMetricsSemanticStyles,
  palette: {
    [PaletteColorsEnum.BLUE]: {
      shade10: colorPrimitive.blurple[1000],
      shade20: colorPrimitive.blurple[900],
      shade30: colorPrimitive.blurple[800],
      shade40: colorPrimitive.blurple[600],
      shade50: colorPrimitive.blurple[500],
    },
  },

  inlineBanner: redesignedDarkInlineBannerSemanticStyles,
  border: redesignedDarkBorderSemanticStyles,

  icon: {
    info: colorPrimitive.blurple['500'],
  },
} satisfies DeepPartial<UserTheme>;

export const redesignedDarkTheme: UserTheme = merge(cloneDeep(darkTheme), overrides);

export const expandedRedesignedDarkTheme: UserTheme = merge(cloneDeep(expandedDarkTheme), overrides);

const darkSidebarOverrides = merge<DeepPartial<UserTheme>, DeepPartial<UserTheme>>(cloneDeep(overrides), {
  leftBar: {
    borderRadius: 16,
    marginLeft: 4,
    marginRight: 4,
    marginBottom: 8,
    background: darkColors.greys.shade10,
  },
});
export const redesignedDarkSidebarTheme: UserTheme = merge(cloneDeep(darkSidebarTheme), darkSidebarOverrides);
